import {useRef, useEffect} from "react";
import Form from "react-bootstrap/Form";
import {easepick} from '@easepick/core';

export default function DatePickerField({
                                          name,
                                          label,
                                          type,
                                          placeholder,
                                          error,
                                          fieldRef
                                        }) {
  const pickerRef = useRef(null);

  useEffect(() => {
    if (pickerRef.current) {
      return;
    }

    pickerRef.current = new easepick.create({
      element: fieldRef.current,
      css: [
        'https://cdn.jsdelivr.net/npm/@easepick/core@1.2.1/dist/index.css',
      ],
    });
  }, []);

  return (
    <Form.Group controlId={name} className="DatePickerField">
      {label && <Form.Label className="small mb-1">{label}</Form.Label>}
      <Form.Control
        type={type || 'text'}
        placeholder={placeholder}
        ref={fieldRef}
      />
      <Form.Text className="text-danger">{error}</Form.Text>
    </Form.Group>
  );
}
